import React from "react";
import "./AdminDashboardHome.css";

function greeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export default function DashboardHeader({ name, lastUpdated, refreshing, onRefresh }) {
  const initial = (name || "A").trim().charAt(0).toUpperCase();

  return (
    <div className="adh-hero">
      <i className="fa-solid fa-gauge-high adh-hero-watermark" aria-hidden="true"></i>

      <div className="adh-hero-main">
        <div className="adh-hero-avatar">{initial}</div>
        <div>
          <div className="adh-hero-eyebrow">Admin Management</div>
          <h2 className="adh-hero-title">{greeting()}{name ? `, ${name}` : ""}</h2>
          <p className="adh-hero-subtitle">
            Manage your organization, projects, tasks, forms and users from one central dashboard.
          </p>
        </div>
      </div>

      <div className="adh-hero-actions">
        {lastUpdated && (
          <span className="adh-hero-updated">
            Updated{" "}
            {lastUpdated.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
          </span>
        )}

        <button
          type="button"
          className="adh-refresh-btn"
          onClick={onRefresh}
          disabled={refreshing}
          aria-label="Refresh dashboard data"
        >
          <i className={`fa-solid fa-rotate${refreshing ? " fa-spin" : ""}`} aria-hidden="true"></i>
          Refresh
        </button>
      </div>
    </div>
  );
}
